"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayCallNode = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const TIdentifierNamesGeneratorFactory_1 = require("../../types/container/generators/TIdentifierNamesGeneratorFactory");
const TStringArrayIndexNodeFactory_1 = require("../../types/container/custom-nodes/string-array-index-nodes/TStringArrayIndexNodeFactory");
const IArrayUtils_1 = require("../../interfaces/utils/IArrayUtils");
const ICustomCodeHelperFormatter_1 = require("../../interfaces/custom-code-helpers/ICustomCodeHelperFormatter");
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const IStringArrayStorage_1 = require("../../interfaces/storages/string-array-transformers/IStringArrayStorage");
const Initializable_1 = require("../../decorators/Initializable");
const AbstractStringArrayCallNode_1 = require("./AbstractStringArrayCallNode");
const NodeFactory_1 = require("../../node/NodeFactory");
const NodeUtils_1 = require("../../node/NodeUtils");
const IStringArrayScopeCallsWrapperData_1 = require("../../interfaces/node-transformers/string-array-transformers/IStringArrayScopeCallsWrapperData");
let StringArrayCallNode = class StringArrayCallNode extends AbstractStringArrayCallNode_1.AbstractStringArrayCallNode {
    constructor(identifierNamesGeneratorFactory, stringArrayIndexNodeFactory, customCodeHelperFormatter, stringArrayStorage, arrayUtils, randomGenerator, options) {
        super(identifierNamesGeneratorFactory, stringArrayIndexNodeFactory, customCodeHelperFormatter, stringArrayStorage, arrayUtils, randomGenerator, options);
    }
    initialize(index, indexShiftAmount, stringArrayCallsWrapperData, decodeKey) {
        this.index = index;
        this.indexShiftAmount = indexShiftAmount;
        this.stringArrayCallsWrapperData = stringArrayCallsWrapperData;
        this.decodeKey = decodeKey;
    }
    getNodeStructure() {
        var _a, _b;
        const resultIndex = this.indexShiftAmount + this.stringArrayCallsWrapperData.index + this.index;
        const indexNode = this.getStringArrayIndexNode(resultIndex);
        const rc4KeyLiteralNode = this.decodeKey
            ? this.getRc4KeyLiteralNode(this.decodeKey)
            : null;
        const callExpressionArgs = this.arrayUtils.fillWithRange(!this.stringArrayCallsWrapperData.parameterIndexesData
            ? AbstractStringArrayCallNode_1.AbstractStringArrayCallNode.stringArrayRootCallsWrapperParametersCount
            : this.options.stringArrayWrappersParametersMaxCount, () => this.getFakeStringArrayIndexNode(resultIndex));
        callExpressionArgs.splice((_b = (_a = this.stringArrayCallsWrapperData.parameterIndexesData) === null || _a === void 0 ? void 0 : _a.valueIndexParameterIndex) !== null && _b !== void 0 ? _b : 0, 1, indexNode);
        if (this.stringArrayCallsWrapperData.parameterIndexesData) {
            callExpressionArgs.splice(this.stringArrayCallsWrapperData.parameterIndexesData.decodeKeyParameterIndex, 1, rc4KeyLiteralNode !== null && rc4KeyLiteralNode !== void 0 ? rc4KeyLiteralNode : this.getFakeStringArrayIndexNode(resultIndex));
        }
        else if (rc4KeyLiteralNode) {
            callExpressionArgs.splice(1, 1, rc4KeyLiteralNode);
        }
        else {
            callExpressionArgs.splice(1, 1);
        }
        const structure = NodeFactory_1.NodeFactory.expressionStatementNode(NodeFactory_1.NodeFactory.callExpressionNode(NodeFactory_1.NodeFactory.identifierNode(this.stringArrayCallsWrapperData.name), callExpressionArgs));
        NodeUtils_1.NodeUtils.parentizeAst(structure);
        return [structure];
    }
    getFakeStringArrayIndexNode(actualIndex) {
        return this.getStringArrayIndexNode(this.getFakeStringArrayIndex(actualIndex));
    }
    getFakeStringArrayIndex(actualIndex) {
        const stringArrayStorageLength = this.stringArrayStorage.getLength();
        const fakeIndexOffset = stringArrayStorageLength / 2;
        const minimumIndex = actualIndex - fakeIndexOffset;
        const maximumIndex = actualIndex + fakeIndexOffset;
        return this.randomGenerator.getRandomInteger(minimumIndex, maximumIndex);
    }
};
exports.StringArrayCallNode = StringArrayCallNode;
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", Object)
], StringArrayCallNode.prototype, "decodeKey", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", Number)
], StringArrayCallNode.prototype, "index", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", Number)
], StringArrayCallNode.prototype, "indexShiftAmount", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_h = typeof IStringArrayScopeCallsWrapperData_1.IStringArrayScopeCallsWrapperData !== "undefined" && IStringArrayScopeCallsWrapperData_1.IStringArrayScopeCallsWrapperData) === "function" ? _h : Object)
], StringArrayCallNode.prototype, "stringArrayCallsWrapperData", void 0);
exports.StringArrayCallNode = StringArrayCallNode = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IStringArrayIndexNode)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ICustomCodeHelperFormatter)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IStringArrayStorage)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IArrayUtils)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(6, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory !== "undefined" && TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory) === "function" ? _a : Object, typeof (_b = typeof TStringArrayIndexNodeFactory_1.TStringArrayIndexNodeFactory !== "undefined" && TStringArrayIndexNodeFactory_1.TStringArrayIndexNodeFactory) === "function" ? _b : Object, typeof (_c = typeof ICustomCodeHelperFormatter_1.ICustomCodeHelperFormatter !== "undefined" && ICustomCodeHelperFormatter_1.ICustomCodeHelperFormatter) === "function" ? _c : Object, typeof (_d = typeof IStringArrayStorage_1.IStringArrayStorage !== "undefined" && IStringArrayStorage_1.IStringArrayStorage) === "function" ? _d : Object, typeof (_e = typeof IArrayUtils_1.IArrayUtils !== "undefined" && IArrayUtils_1.IArrayUtils) === "function" ? _e : Object, typeof (_f = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _f : Object, typeof (_g = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _g : Object])
], StringArrayCallNode);
